// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1ksoP","question":"styles_question__1bum7","itemWrapper":"styles_itemWrapper__3V6I8"};